const stageGridConfig: any = {
  defaultSort: [{ field: 'number', dir: 'asc' }],
  columns:
    [
      {
        field: 'number',
        title: 'Stage No.',
        filter: 'numeric',
        _width: 80
      },
      {
        field: 'name',
        title: 'Stage Name',
        filter: 'text',
        _width: 120,
      },
      {
        field: 'description',
        title: 'Description',
        filter: 'text',
        _width: 220,
      },
      {
        field: 'locationCount',
        title: 'Locations',
        filter: 'numeric',
        clickable: true,
        _width: 70,
      },
      {
        field: 'coaCount',
        title: 'COAs',
        filter: 'numeric',
        clickable: true,
        _width: 70,
      },
      {
        field: '_actions',
        title: 'Actions',
        filterable: false,
        sortable: false,
        _width: 140,
      },
    ]
};

export default stageGridConfig;



// WEBPACK FOOTER //
// ./src/pages/setup/project-details/project-detail-stage-grid/project-detail-stage-grid.config.ts